if (!customElements.get("included-optional-component")) {
  customElements.define(
    "included-optional-component",
    class IncludedOptionalProducts extends HTMLElement {
      constructor() {
        super();
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.loaddata()
      }
      connectedCallback() {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
        
        };
        new IntersectionObserver(handleIntersection.bind(this), {
          rootMargin: "0px 0px 400px 0px",
        }).observe(this);
      }
      loaddata(){
         var csvurl = $(".included-component-wrapper").data("csvfile");
          var jsonarr = [];

          var this3 = this;

          $.ajax({
            type: "GET",
            url: csvurl,
            dataType: "text",
            success: function (data) {
              var csvData = data;
              let word_array = $.csv.toArrays(csvData);

              for (let index = 1; index < word_array.length; index++) {
                var ob = {}; 
                ob["category"] = word_array[index][0];
                ob["fabric"] = word_array[index][1].replace(
                  /[^a-zA-Z0-9 ]/g,
                  ""
                ); 
                ob["name"] = word_array[index][2];
                ob["handle"] = word_array[index][3];
                ob["quantity"] = word_array[index][4];
                ob["included"] = word_array[index][5];
                jsonarr.push(ob);
              }

              setDataInPage(jsonarr);
            },
          });

          function setDataInPage(data) {
            var tags = $(".included-component-wrapper").data("tags");
            var artags = tags.split(",");
            var arinitial = [];
            for (let i = 0; i < artags.length; i++) {
              var tag = artags[i].split("_");
              if (tag[0] == "CATEGORY") {
                arinitial.push(tag[1]);
              }
              if (tag[0] == "FABRIC") {
                arinitial.push(artags[i].replace(/[^a-zA-Z0-9 ]/g, ""));
              }
            }
             

            var found = false;
            var currentdata = [];
            for (let i = 0; i < data.length; i++) {
              
              if (
                arinitial.includes(data[i]["category"]) &&
                arinitial.includes(data[i]["fabric"])
              ) {
                found = true;
                currentdata.push(data[i]);
              }
            } 

            if (currentdata.length > 0) {
              var index = 0;
              loadProducts(index);
              function loadProducts(index) { 
                var str = "";
                var indata = currentdata[index];
                jQuery.getJSON(
                  window.Shopify.routes.root +
                    "products/" +
                    indata["handle"] +
                    ".js",
                  function (product) { 
                    var price = product.price / 100;
                    price = price.toFixed(2);
                    var prices = "$" + price;
                    var addqty = ''
                    if (indata["included"] == "1") {
                      prices = "Free";
                      addqty = 'style="pointer-events:none;display:none;"';
                    }

                    var varid = product.variants[0].id;

                    str =
                      str +
                      `<div
                        class="component-item"
                        data-included = "${indata["included"]}"
                        data-productid="${varid}"
                        data-mainpid="${product.handle}"
                        data-productname="product_${index}"
                        data-price="${price}"
                      >
                        <div class="component-pro-wrapper">
                          <div class="image-container">
                            <img src="${product.featured_image}">
                          </div>
                          <div class="main-pro-title">
                          <div class="pro-title">${product.title}</div>
                          
                          </div>
                          <div class="component-quantity" ${addqty}>
                            <div class="number">
                              <span class="minus"></span>
                              <input type="number" class="component-qty component-qty-main" min="0" value="0" step="${indata["quantity"]}">
                              <span class="plus"></span>
                            </div>
                          </div> 
                          <div class="component-price component-price-main">${prices}</div>
                          <div class=" included-modal">
                            <div class="included-modal-content description-model-wrapper">
                              <span class="included-close">&times;</span>
                              <div class="image-wrapper">
                                <img src="${product.featured_image}">
                              </div>
                              <div class="product-desc-wrapper">
                                <div class="product-title">${product.title}</div>
                                <div class="component-price">${prices}</div>
                                <div class="product-desc">${product.description}</div>
                                <div style="display:none;" class="component-quantity" ${addqty}>
                                  <div class="number">
                                    <span class="minus"></span>
                                    <input type="number" class="component-qty" min="0" value="0" step="${indata["quantity"]}">
                                    <span class="plus"></span>
                                  </div>
                                </div>
                                 
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>`;
                    $(".included-component-wrapper").append(str);
                    if (index < currentdata.length - 1) {
                      index++;
                      loadProducts(index);
                    } else {
                      
                      $(".included-component-wrapper").parents('included-optional-component').addClass('included-optional-component');
                      $(".included-component-wrapper").parents('included-optional-component').css("display","block");
                      
                      $(".included_free_label").show();
                      $(".model-add-to-cart,.included-add-to-cart")
                        .unbind()
                        .click(function (params) {
                          const config = fetchConfig("javascript");
                          config.headers["X-Requested-With"] = "XMLHttpRequest";
                          delete config.headers["Content-Type"];
                          const formData = new FormData();
                          if (this3.cart) {
                            formData.append(
                              "sections",
                              this3.cart
                                .getSectionsToRender()
                                .map((section) => section.id)
                            );
                            formData.append(
                              "sections_url",
                              window.location.pathname
                            );
                            this3.cart.setActiveElement(document.activeElement);
                          }
                          var quantity = $(this)
                            .parent()
                            .find(".component-qty").val();
                          formData.append("id", $(this).data("varid"));
                          formData.append("quantity", quantity);
                          config.body = formData;

                          var this2 = this;
                          $(
                            this
                          ).html(`<div class="loading-overlay__spinner" bis_skin_checked="1">
                          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle style="stroke:white;" class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                          </svg>
                        </div>`);

                          fetch(`${routes.cart_add_url}`, config)
                            .then((response) => response.json())
                            .then((response) => {
                              if (response.status) {
                                $(this2).after(
                                  `<div class="error-message-upsell" style="font-weight:500;margin-top:10px;line-height:1.6;color:red;font-size:12px;text-align:center;">${response.description}</div>`
                                );
                                return;
                              } else if (!this3.cart) {
                                window.location = window.routes.cart_url;
                                return;
                              }
                              this3.cart.renderContents(response);
                              $(this).parents(".included-modal").hide();
                            })
                            .catch((e) => {
                              console.error(e);
                            })
                            .finally(() => {
                              if (
                                $(this)
                                  .parent()
                                  .hasClass("included-modal-content")
                              ) {
                                $(this2).html("Add To Cart");
                              } else {
                                $(this2).html("ADD");
                              }
                            });
                        });
                      $(".component-pro-wrapper .image-container").click(
                        function () {
                          $(this).parent().find(".included-modal").fadeIn();
                        }
                      );
                      $(".component-pro-wrapper .pro-title").click(function () {
                        $(this).parents('.component-item').find(".included-modal").fadeIn();
                      });
                      $(".included-close").click(function () {
                        $(".included-modal").fadeOut();
                      });

                      $(".minus").on("click", function () {
                        var $input = $(this).parent().find("input");
                        var $step = Number($(this).parent().find("input").attr('step'));
                        var count = parseInt($input.val()) - $step;
 
                         
                          count = count < 0 ? 0 : count;
                          $input.val(count);
                          $input.change();
                          updateTotal();
                        
                        return false;
                      });

                      $(".plus").on("click", function () {
                        var $input = $(this).parent().find("input");
                        var $step = Number($(this).parent().find("input").attr('step'));
                        var count = parseInt($input.val()) + $step;
                        
                        $input.val(parseInt($input.val()) + $step);
                        $input.change();
                        updateTotal();
                        return false;
                      });

                      function updateTotal(quantity) {
                        $(".component-item").each(function () {
                          var quantityElement = $(this).find(
                            ".component-quantity .number"
                          );
                          var input = quantityElement.find("input");
                          var quantity = parseFloat(input.val()) || 0;
                         $(this).find('.included-modal .component-qty').val(quantity)
                          if (quantity > 0 && $(this).attr('data-included') != 1) {
                            var price = parseFloat($(this).data("price"));
                            var calprice = quantity * price;

                            $(this)
                              .find(".component-pro-wrapper .component-price-main")
                              .text("$" + calprice.toFixed(2));
                             
                          } else (
                            $(this).find(".component-price").text() == "Free"
                          )  
                        });
                        // $(".included-modal").each(function () {
                        //   var quantityElement = $(this).find(
                        //     ".component-quantity .number"
                        //   );
                        //   var input = quantityElement.find("input");
                        //   var quantity = parseFloat(input.val()) || 0;
                        //   $(this).parents('.component-item').find('.component-qty').val(quantity)
                        //   if (quantity > 0 && $(this).attr('data-included') != 1) {
                        //     var price = parseFloat($(this).parents('.component-item').data("price"));
                        //     var calprice = quantity * price;

                        //     $(this)
                        //       .find(".component-price")
                        //       .text("$" + calprice);
                             
                        //   } else (
                        //     $(this).find(".component-price").text() == "Free"
                        //   )  
                        // });
                      }
                      updateTotal();
                    }
                  }
                );
              }

              // $(".included-component-wrapper").html(str);
            }
          }
      }
    }
  );
}
